import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { color, fontWeight, fontSize, radius } from '@ticketswap/solar'
import { createLittleCalendarFormatter } from '~/utils/date/createLittleCalendarFormatter'
import { useLanguage } from '../LanguageContext'

const Container = styled.div`
  display: block;
  border-radius: ${radius.sm};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 42px;
`

const Header = styled.header`
  background-color: ${color.mars};
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-top-left-radius: ${radius.sm};
  border-top-right-radius: ${radius.sm};
  color: ${color.nova};
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  line-height: 1;
  padding: 3px 0 2px;

  [data-theme='dark'] & {
    color: ${color.space};
  }

  @supports (-webkit-overflow-scrolling: touch) {
    /* The above padding looks off in mobile Safari, so here goes... */
    padding: 4px 0 1px;
  }
`

const Body = styled.div`
  font-size: ${fontSize[14]};
  font-weight: ${fontWeight.bold};
  color: ${color.space};
  line-height: 1;
  padding: 6px 0 6px;
  background-color: ${color.nova};
  border-bottom-left-radius: ${radius.sm};
  border-bottom-right-radius: ${radius.sm};

  [data-theme='dark'] & {
    background-color: ${color.space};
    color: ${color.nova};
  }
`

const LittleCalendar = ({ startDate, endDate }) => {
  const language = useLanguage()
  const formatter = createLittleCalendarFormatter(language)
  const formattedDate = formatter(startDate, endDate)

  return (
    <Container>
      <Header>{formattedDate.header}</Header>
      <Body>{formattedDate.body}</Body>
    </Container>
  )
}

LittleCalendar.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
}

export default LittleCalendar
